import whatMakesACardValuable from "./whatMakesACardValuable";
import howToStart from "./how-to-start-a-trading-card-collection-on-budget";
import theHistoryOfTradingCards from "./the-history-of-trading-cards-from-tobacco-to-digital";
import top10ValuableSportsCards from "./top-10-most-valuable-sports-cards-ever-sold";
import beginnersGuideToPokemonCardCollecting from "./beginners-guide-to-pokemon-card-collecting";
import theRiseOfMagicTheGatheringInTheTradingCardWorld from "./the-rise-of-magic-the-gathering-in-the-trading-card-world";
import understandingCardRarityWhatMakesACardValuable from "./understanding-card-rarity-what-makes-a-card-valuable";
import howToSpotFakeTradingCardsAndAvoidScams from "./how-to-spot-fake-trading-cards-and-avoid-scams";
import bestPracticesForStoringAndProtectingYourCards from "./best-practices-for-storing-and-protecting-your-cards";
import howToGradeYourOwnCardsAtHomeTipsAndTools from "./how-to-grade-your-own-cards-at-home-tips-and-tools";
import theImpactOfGradingCompaniesOnCardValues from "./the-impact-of-grading-companies-on-card-values";
import rookieCardsWhyTheyMatterAndHowToFindThem from "./rookie-cards-why-they-matter-and-how-to-find-them";
import investingInTradingCardsLongTermVsShortTermStrategies from "./investing-in-trading-cards-long-term-vs-short-term-strategies";
import theRoleOfAutographsInTradingCardValue from "./the-role-of-autographs-in-trading-card-value";
import howToBuildAThemedDeckForMagicOrPokemon from "./how-to-build-a-themed-deck-for-magic-or-pokemon";
import theEvolutionOfCardDesignThroughTheDecades from "./the-evolution-of-card-design-through-the-decades";
import top5TradingCardGamesToWatchIn2025 from "./top-5-trading-card-games-to-watch-in-2025";
import howCardShowsWorkTipsForFirstTimeAttendees from "./how-card-shows-work-tips-for-first-time-attendees";
import whatAreParallelAndAlternateArtCards from "./what-are-parallel-and-alternate-art-cards";
import howToUseOnlineMarketplacesSafelyForCardTrading from "./how-to-use-online-marketplaces-safely-for-card-trading";
import understandingPSABGSAndSGCGradingScales from "./understanding-psa-bgs-and-sgc-grading-scales";
import theMostIconicCardsInSportsHistory from "./the-most-iconic-cards-in-sports-history";
import howToSellYourCardsOnlineForMaximumProfit from "./how-to-sell-your-cards-online-for-maximum-profit";
import howToHandleDamagedCardsRestorationAndImpact from "./how-to-handle-damaged-cards-restoration-and-impact";
import theScienceBehindCardConditionAndGrading from "./the-science-behind-card-condition-and-grading";
import topTipsForTradingCardsWithFriendsAndCollectors from "./top-tips-for-trading-cards-with-friends-and-collectors";
import howDigitalTradingCardsAreChangingTheHobby from "./how-digital-trading-cards-are-changing-the-hobby";
import whatYouNeedToKnowAboutCardAuthenticationServices from "./what-you-need-to-know-about-card-authentication-services";
import theImpactOfPopCultureOnTradingCardPopularity from "./the-impact-of-pop-culture-on-trading-card-popularity";
import howToSpotMisprintsAndErrorCards from "./how-to-spot-misprints-and-error-cards";
import theBestStorageSolutionsSleevesToploadersAndBinders from "./the-best-storage-solutions-sleeves-toploaders-and-binders";
import understandingMarketTrendsAndPriceFluctuations from "./understanding-market-trends-and-price-fluctuations";
import howToAttendACardAuctionWhatToExpect from "./how-to-attend-a-card-auction-what-to-expect";
import top10LegendaryCardsEveryCollectorDreamsOf from "./top-10-legendary-cards-every-collector-dreams-of";
import theArtOfCardPhotographyForSellingAndShowcasing from "./the-art-of-card-photography-for-selling-and-showcasing";
import howToGetStartedWithYuGiOhCardCollecting from "./how-to-get-started-with-yu-gi-oh-card-collecting";
import tradingCardInsuranceIsItWorthIt from "./trading-card-insurance-is-it-worth-it";
import famousCardCollectionsAndTheirStories from "./famous-card-collections-and-their-stories";
import howToProtectCardsFromSunlightHumidityAndHeat from "./how-to-protect-cards-from-sunlight-humidity-and-heat";
import thePsychologyOfCollectingWhyWeLoveTradingCards from "./the-psychology-of-collecting-why-we-love-trading-cards";
import theFutureOfTradingCardsNFTsAndBlockchain from "./the-future-of-trading-cards-nfts-and-blockchain";
import howToOrganizeYourCardCollectionEfficiently from "./how-to-organize-your-card-collection-efficiently";
import keyDifferencesBetweenSportsCardsAndTCGs from "./key-differences-between-sports-cards-and-tcgs";
import bestPracticesForShippingCardsSafely from "./best-practices-for-shipping-cards-safely";
import howToNetworkInTheTradingCardCommunity from "./how-to-network-in-the-trading-card-community";
import theMostExpensiveCardsEverSoldAtAuction from "./the-most-expensive-cards-ever-sold-at-auction";
import whatToLookForWhenBuyingVintageCards from "./what-to-look-for-when-buying-vintage-cards";
import howToBuildATradingCardPortfolioForInvestment from "./how-to-build-a-trading-card-portfolio-for-investment";
import theRoleOfGradingPopulationReportsInPricing from "./the-role-of-grading-population-reports-in-pricing";
import howSocialMediaInfluencesTradingCardMarkets from "./how-social-media-influences-trading-card-markets";
import theUltimateChecklistForFirstTimeCardBuyers from "./the-ultimate-checklist-for-first-time-card-buyers";

const blogs = [
  whatMakesACardValuable,
  howToStart,
  theHistoryOfTradingCards,
  top10ValuableSportsCards,
  beginnersGuideToPokemonCardCollecting,
  theRiseOfMagicTheGatheringInTheTradingCardWorld,
  understandingCardRarityWhatMakesACardValuable,
  howToSpotFakeTradingCardsAndAvoidScams,
  bestPracticesForStoringAndProtectingYourCards,
  howToGradeYourOwnCardsAtHomeTipsAndTools,
  theImpactOfGradingCompaniesOnCardValues,
  rookieCardsWhyTheyMatterAndHowToFindThem,
  investingInTradingCardsLongTermVsShortTermStrategies,
  theRoleOfAutographsInTradingCardValue,
  howToBuildAThemedDeckForMagicOrPokemon,
  theEvolutionOfCardDesignThroughTheDecades,
  top5TradingCardGamesToWatchIn2025,
  howCardShowsWorkTipsForFirstTimeAttendees,
  whatAreParallelAndAlternateArtCards,
  howToUseOnlineMarketplacesSafelyForCardTrading,
  understandingPSABGSAndSGCGradingScales,
  theMostIconicCardsInSportsHistory,
  howToSellYourCardsOnlineForMaximumProfit,
  howToHandleDamagedCardsRestorationAndImpact,
  theScienceBehindCardConditionAndGrading,
  topTipsForTradingCardsWithFriendsAndCollectors,
  howDigitalTradingCardsAreChangingTheHobby,
  whatYouNeedToKnowAboutCardAuthenticationServices,
  theImpactOfPopCultureOnTradingCardPopularity,
  howToSpotMisprintsAndErrorCards,
  theBestStorageSolutionsSleevesToploadersAndBinders,
  understandingMarketTrendsAndPriceFluctuations,
  howToAttendACardAuctionWhatToExpect,
  top10LegendaryCardsEveryCollectorDreamsOf,
  theArtOfCardPhotographyForSellingAndShowcasing,
  howToGetStartedWithYuGiOhCardCollecting,
  tradingCardInsuranceIsItWorthIt,
  famousCardCollectionsAndTheirStories,
  howToProtectCardsFromSunlightHumidityAndHeat,
  thePsychologyOfCollectingWhyWeLoveTradingCards,
  theFutureOfTradingCardsNFTsAndBlockchain,
  howToOrganizeYourCardCollectionEfficiently,
  keyDifferencesBetweenSportsCardsAndTCGs,
  bestPracticesForShippingCardsSafely,
  howToNetworkInTheTradingCardCommunity,
  theMostExpensiveCardsEverSoldAtAuction,
  whatToLookForWhenBuyingVintageCards,
  howToBuildATradingCardPortfolioForInvestment,
  theRoleOfGradingPopulationReportsInPricing,
  howSocialMediaInfluencesTradingCardMarkets,
  theUltimateChecklistForFirstTimeCardBuyers
];

export default blogs;
